module.exports = __webpack_public_path__ + "static/media/galerija_2018 (3).ca0a087c.jpg";